import { prefixes, prependIntlIds } from "../utils";

const adminPrepend = "🛠️";

export const unprefixedPageTitleMessages = {
  login: "Přihlášení",
  reset_password: "Obnovit heslo",
  registration: "Registrace",

  hwr: "HWR",
  overview: "📋 {templateName}",
  detail: "🔎 {templateName}",
  edit: "🖊 {templateName}",

  homepage: "Hlavní nabídka",
  settings: "Nastavení",

  template_builder: "🏗️ {templateName}",
  administration: adminPrepend,

  "administration.data_sources": `${adminPrepend} datové zdroje`,
  "administration.functions": `${adminPrepend} funkce`,
  "administration.information": `${adminPrepend} informace`,
  "administration.modules": `${adminPrepend} moduly`,
  "administration.personalization": `${adminPrepend} přizpůsobení`,
  "administration.roles": `${adminPrepend} role`,
  "administration.templates": `${adminPrepend} šablony`,
  "administration.tables": `${adminPrepend} tabulky`,
  "administration.users": `${adminPrepend} uživatelé`,
} as const;

export default prependIntlIds(prefixes.pageTitle, unprefixedPageTitleMessages);
